import React from "react"
import SimpleBar from "simplebar-react"
import "simplebar/dist/simplebar.min.css"

import STYLE from "../styles/components/section.module.scss"
import sanitizeHtml from "sanitize-html"
import sanitizerConfig from "../config/sanitizer"
class DynamicContent extends React.Component {
  // przy przenoszeniu trzeba będzie zmienić dostęp we wtyczce CORS do wp tylko dla gatsby
  componentDidMount() {

    function dynamicContent() {
      document.querySelectorAll(".scroll_container [data]").forEach(node => {

        const data = JSON.parse(node.getAttribute("data"));
        node.removeAttribute("data");

        const container = node.querySelector(".wp-block-column");

        const form_header = document.createElement("h1");
        form_header.setAttribute("form_header", "");
        form_header.innerHTML = `<span>Kancelaria adwokacka</span> ${data.osobaKontaktowa}`;

        const form_footer = document.createElement("div");
        form_footer.setAttribute("form_footer", "");
        const tel = JSON.stringify(data.numerTelefonu);
        form_footer.innerHTML = `
          <div contact_column>
            <h3>Telefon</h3>
            <a href="tel:${tel}">${tel[0]}${tel[1]}${tel[2]} ${tel[3]}${tel[4]}${tel[5]} ${tel[6]}${tel[7]}${tel[8]}</a>
          </div>
          <div contact_column>
            <h3>Mail</h3>
            <a href="mailto:${data.eMail}">${data.eMail}</a>
          </div>
        `;
        container.prepend(form_header);
        container.appendChild(form_footer);
      })
    }
    dynamicContent();
  }
  render() {
    return null;
  }
}
class ContentHeightScript extends React.Component {
  componentDidMount() {
      let cont = document.querySelector("section");
      cont.setAttribute("style", "height:"+cont.getBoundingClientRect().height+"px");
      window.addEventListener("resize", () => cont.setAttribute("style", "height:"+cont.getBoundingClientRect().height+"px"));
  }
  render() {
      return null;
  }
}
class WpColumnsFix extends React.Component {
  componentDidMount() {
      document.querySelectorAll(".wp-block-columns").forEach((columnsBox, i) => {
        columnsBox.id = "columnsBox_"+i;
        let styleFix = document.createElement("style");
        styleFix.innerHTML = `
          @media all and (min-width: 992px) {
            #columnsBox_${i} .wp-block-column {
              max-width: calc(${100 / columnsBox.children.length}% - ${parseInt(window.getComputedStyle(columnsBox.children[0], null).getPropertyValue("padding-left")) + parseInt(window.getComputedStyle(columnsBox.children[0], null).getPropertyValue("padding-right"))}px);
            }
          }`
        columnsBox.appendChild(styleFix);
      })
  }
  render() {
      return null;
  }
}
const Section = props => {
  return (
    <section className={STYLE.SECTION} page-title={props.pageTitle}>
      <h1 className="page_title">{props.pageTitle}</h1>

      <SimpleBar className="scroll_container" scrollbarMaxSize={20}>
        <div
          dangerouslySetInnerHTML={{
            __html:
              //  props.dynamicContent ||
              (props.dynamicContent &&
                sanitizeHtml(props.dynamicContent, sanitizerConfig)),
          }}
        data={JSON.stringify(props.contact)}></div>
      </SimpleBar>
      <ContentHeightScript/>
      <WpColumnsFix/>
      {props.pageTitle === "Kontakt" ? <DynamicContent></DynamicContent> : null}

    </section>
  )
}

export default Section
